import React from 'react'

const MatchContext = React.createContext({})

export { MatchContext }
